import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    lastError: simpleReducer(null, {
        CATCH_ERROR: (a) => a.payload.error,
        ACKNOWLEDGE_ERROR: null,
    }),

    errorMessage: simpleReducer(null, {
        SET_ERROR_MESSAGE: (a) => a.payload.message,
        ACKNOWLEDGE_ERROR: null,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/error.js